<template>
    <div class="page post-page">
        <div class="hero-banner">
            <wp-image :image="heroBanner"
                      :isBackground="true"
                      classes="background"
            />
        </div>

        <div class="wrap-content">

            <div class="left">
                <h5>Share With Friends</h5>

                <ul class="share-links-list">
                    <li v-for="(social, i) in socialLinks"
                        :key="`social-link-${i}`"
                        class="social-media-item">
                        <a :href="social.url"  class="social-media-link"
                           :target="social.network !== 'Email' ? '_blank':''">
                            <font-awesome-icon class="icon" :icon="getSocialIcon(social.network)"/>
                        </a>
                    </li>
                </ul>

            </div>

            <div class="right">

                <h1 v-if="postTitle">{{postTitle.rendered}}</h1>
                <div class="date">{{date}} {{categoryList}}</div>

                <div class="content" v-html="postBody"></div>

            </div>
        </div>

        <div class="post-links">
            <div class="prev-post">
                <router-link v-if="prevPost" class="post-link prev-post-link" :to="prevPost.slug">
                    <h3 class="post-block-title">Previous Post</h3>
                    <post-block v-bind="prevPost" :id="prevPost.ID" />
                </router-link>
            </div>
            <div class="next-post">
                <router-link v-if="nextPost" class="post-link next-post-link" :to="nextPost.slug">
                    <h3 class="post-block-title">Next Post</h3>
                    <post-block v-bind="nextPost" :id="nextPost.ID" />
                </router-link>
            </div>
        </div>


    </div>
</template>

<script>
    import HeroModule from '../modules/HeroModule'
    import {wpPostApi} from '@/utils/api'
    import {razzNextPrevPostApi} from '@/utils/api'
    import PostBlock from '../modules/components/PostBlock'
    import ctaBlockModule from '../modules/ctaBlockModule'
    import ButtonLink from '../modules/components/ButtonLink'
    import faFacebookF from '@fortawesome/fontawesome-free-brands/faFacebookF'
    import faTwitter  from '@fortawesome/fontawesome-free-brands/faTwitter'
    import { faEnvelope }  from '@fortawesome/free-solid-svg-icons/faEnvelope'
    import { EventBus } from "../utils/EventBus";

    export default {
        name: "Post",
        props: {
            id: [String, Number],
            type: String
        },
        components: {
            HeroModule,
            PostBlock,
            ctaBlockModule,
            ButtonLink
        },
        data() {
            return {
                defaultCTA: wp.settings.defaultCTA,
                socialIcons: {
                    faFacebookF,
                    faTwitter,
                    faEnvelope
                }
            }
        },
        metaInfo() {
            return {
                title: this.title
            }
        },
        mounted(){
            document.body.classList.add('single-post');
        },
        beforeDestroy(){
            document.body.classList.remove('single-post');
        },
        asyncComputed: {
            postContent() {
                return wpPostApi.get(`${this.id}`).then((res) => {
                    this.$emit('pageLoaded');
                    EventBus.setPageLoaded(true);
                    this.$scrollTo('body', 100, {offset: 1});
                    return res.data
                })
            },
            nextPrevPosts() {
                return razzNextPrevPostApi.get(`${this.id}`).then(res => res.data)
            }
        },
        computed: {
            prevPost() {
                return this.nextPrevPosts && this.nextPrevPosts.prev
            },
            nextPost() {
                return this.nextPrevPosts && this.nextPrevPosts.next
            },
            postTitle() {
                return this.postContent && this.postContent.title
            },
            link() {
                return this.postContent && this.postContent.link
            },
            heroModule() {
                return this.modules && this.modules.hero
            },
            date() {
                if (!this.postContent) return '';

                const date = new Date(this.postContent.date);
                return date.toLocaleDateString('en-US').replace(new RegExp('\\/', 'g'), '.');
            },
            categoryList() {

                if (!this.postContent || !this.postContent.categories) return '';

                const categories = this.postContent && this.postContent.categories.map((category) => {
                    return category.name
                });

                if (categories.length === 1) {
                    return `| ${categories[0]}`;
                }

                return `| ${categories.join(', ')}`
            },
            socialLinks() {
                return [
                    {network: 'Facebook', url: `https://www.facebook.com/sharer/sharer.php?u=${this.link}`},
                    {network: 'Twitter', url: `https://twitter.com/home?status=${this.link}`},
                    {network: 'Email', url: `mailto:?&subject=I'd like to share a link with you&body=${this.link}`}
                ]
            },
            modules() {
                return this.postContent && this.postContent.acf
            },
            heroBanner(){
                return this.modules && (this.modules.banner || this.modules.thumbnail);
            },
            postBody() {
                return this.modules && this.modules.post_content
            },
            yoastMetaTags() {
                return this.postContent && this.postContent.yoast_meta
            },
            siteName() {
                return wp && wp.site_name || 'Living at Santa Monica';
            },
            title() {
                let title = this.yoastMetaTags && this.yoastMetaTags.yoast_wpseo_title;

                if (title) {
                    return title.replace('%%sep%%', '|').replace('%%sitename%%', this.siteName);
                } else {
                    return this.siteName;
                }   
            },
        },
        methods: {
            getSocialIcon(network) {
                switch (network) {
                    case 'Facebook':
                        return this.socialIcons.faFacebookF;
                    case 'Twitter':
                        return this.socialIcons.faTwitter;
                    case 'Email':
                    default:
                        return this.socialIcons.faEnvelope;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .post-page{
        background-color: #fff;
    }

    .hero-banner{
        height: 500px;
        width: 100%;
        margin-top: 257px;

        @media (max-width: 1100px){
            margin-top: 150px;
            height: 400px;
        }

        .background{
            background: no-repeat center center transparent;
            background-size: cover;
            width: 100%;
            height: 100%;
        }
    }

    .wrap-content{
        width: 1150px;
        @include max-width();
        margin: 100px auto 80px;
        display: flex;
        padding-bottom: 80px;
        border-bottom: 2px solid $color1;

        @media (max-width: 992px){
            flex-direction: column;
            margin-top: 50px;
            margin-bottom: 50px;
        }

        .left{
            width: 430px;

            @media (max-width: 1100px){
                width: 200px;
            }

            @media (max-width: 992px){
                width: 100%;
                margin-top: 50px;
            }

            h5{
                margin-top: 0;
                font-weight: $font-weight--light;
            }
        }

        .share-links-list{
            list-style: none;
            padding: 0;
            margin: 0;

            li{
                margin: 10px 0;

                @media (max-width: 992px){
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0 10px;

                    &:first-child{
                        margin-left: 0;
                    }
                }
            }

            a{
                display: inline-block;
                width: 40px;
                text-align: center;
                background-color: $color2;
                border-radius: 50%;
                height: 40px;
                padding: 7px 0;
                color: #fff;
                overflow: hidden;
                position: relative;

                @media (max-width: 992px){
                    font-size: 23px;
                }

                svg {
                    position: relative;
                    z-index: 2;
                }

                &::after{
                    content: "";
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                    background-color: rgba(#000, 0);
                    transition: all .3s ease-in-out;
                    z-index: 1;
                }

                &:hover, &:focus {
                    &::after{
                        background-color: rgba(#000, .10);
                    }
                }
            }

        }

        .right{
            width: calc(100% - 430px);

            @media (max-width: 1100px){
                width: calc(100% - 200px);
            }

            @media (max-width: 992px){
                width: 100%;
                order: -1;
            }

            .content{
                margin-top: 45px;
            }
        }
    }

    .post-links{
        width: 1150px;
        @include max-width();
        margin: 0 auto 80px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        @media (max-width: 767px){
            flex-direction: column;
        }

        .post-block-title{
            color: #000;
            font-weight: $font-weight--light;
            margin-bottom: 15px;
        }

        .prev-post{
            width: calc(50% - 15px);

            @media (max-width: 767px){
                width: 100%;
                margin-bottom: 20px;
            }
        }

        .next-post{
            width: calc(50% - 15px);
            align-self: flex-end;

            @media (max-width: 767px){
                width: 100%;
                margin-bottom: 20px;
            }
        }

        /deep/ .content-container{
            a{
                color: $color1;
            }
        }

        /deep/ a {
            text-decoration: none;
        }
    }


</style>